import type { ganttFilterType } from "./prop-types";

/**
 * Initial/default values for Gantt filters.
 * This is in a separate file to avoid pulling in Bryntum dependencies
 * for code that only needs these constants.
 */
export const INITIAL_GANTT_FILTER: ganttFilterType = {
   jobTitles: [],
   projectStatuses: [],
   resourceStatuses: [],
   assignmentsOrRequests: [],
   projectStages: [],
   peopleOrEquipment: [],
   hidePast: false,
   hideEmptyProject: false,
   hideEmptyCategories: false,
   hideTypeLabor: false,
   hideTypeEquipment: false,
   hideAssignments: false,
   hideRequests: false,
   customFieldsFilters: {},
   projectTags: [],
   projectRoles: [],
   projects: [],
};
